import { AlignHorizontalCenter } from "@mui/icons-material";
import React from "react";

const Recipes = () => {
  return (
    <div className="recipes-wrapper">
    <div className="header">
      <h1>Recipes</h1>
    </div>
    <hr className="custom-line" />
    <div className="section">
      <div className="footer-left">
        <a href="#rhodium-oatmeal">Rhodium Oatmeal</a>  
        <span className="separator">|</span>
        <a href="#mediterranean-salad">Mediterranean Salad</a>
      </div>
    </div>
    <div className="section" id="recipes">
        <h2 id="rhodium-oatmeal">Rhodium Oatmeal</h2>
        <p>Note: I recently cut the hemp hearts and Pecans out of here and instead use walnuts and added Barberries, Cranberry Powder, Cinnamon, and Ginger Powder. </p>
        <h3>Ingredients</h3>
        <ul>
          <li>1/2 cup rolled oats</li>
          <li>1/4 cup raisins</li>
          <li>1/4 cup flax seeds</li>
          <li>1/4 cup hemp hearts</li>
          <li>1/4 cup fresh blueberries</li>
          <li>1/4 cup of Pecans (You can swap other Nuts here too)</li>
          <li>3/4 cup unsweetened almond milk</li>
        </ul>
        <p>Note: Sometimes a use similar ingredients and swap out the oatmeal for yogurt.  In addition, I may include strawberries, blackberries, chia seeds, pine nuts or walnuts.</p>
        <h3>Instructions</h3>
        <ul>
          <li>Cook oatmeal as directed, which is usually about 5 minutes.</li>
          <li>
            While the oats are cooking, put flax seeds, hemp hearts, raisins, and
            blueberries all in a bowl.
          </li>
          <li>
            When oatmeal is done, add to the mix in the bowl and stir lightly
            mixing all ingredients.
          </li>
          <li>
            Pour in cold almond milk and enjoy the warm and cold mix together.
          </li>
        </ul>

        <h3>Estimated Nutritional Breakdown</h3>
        <ul>
          <li>
            Rolled Oats (1/2 cup): Calories: 77 | Protein: 3g | Fiber: 2g |
            Healthy Fats: 1.5g | Carbs: 13.5g
          </li>
          <li>
            Raisins (1/4 cup): Calories: 108 | Protein: 1g | Fiber: 1g | Healthy
            Fats: 0.1g | Carbs: 29g
          </li>
          <li>
            Flax Seeds (1/4 cup): Calories: 150 | Protein: 5g | Fiber: 7g |
            Healthy Fats: 11g | Carbs: 8g
          </li>
          <li>
            Hemp Hearts (1/4 cup): Calories: 180 | Protein: 10g | Fiber: 1g |
            Healthy Fats: 15g | Carbs: 2g
          </li>
          <li>
            Blueberries (1/4 cup): Calories: 21 | Protein: 0.3g | Fiber: 0.9g |
            Healthy Fats: 0.1g | Carbs: 5g
          </li>
          <li>
            Unsweetened Almond Milk (3/4 cup): Calories: 30 | Protein: 1g |
            Fiber: 0.5g | Healthy Fats: 2.5g | Carbs: 1g
          </li>
          <li>
            Pecans (1/4 cup): Calories: 200 | Protein: 2.5g | Fiber: 2.7g |
            Healthy Fats: 20g | Carbs: 4g
          </li>
        </ul>
        <p>
          Totals: Calories: 766 | Protein: 22.8g | Fiber: 15.1g | Healthy Fats:
          50.2g | Carbs: 62.5g
        </p>

        <h3>Key Vitamins and Minerals</h3>
        <ul>
          <li>
            Vitamin E from almond milk and pecans (antioxidant support)
          </li>
          <li>
            Magnesium from oats, flax seeds, and pecans (muscle and nerve
            function)
          </li>
          <li>Iron from oats and flax seeds (supports oxygen transport)</li>
          <li>
            Vitamin C from blueberries (immune support and collagen synthesis)
          </li>
          <li>Calcium from almond milk (bone health)</li>
          <li>
            Manganese from pecans (metabolism and bone health)
          </li>
          <li>
            Copper from pecans (energy production and iron metabolism)
          </li>
        </ul>

        <h3>Longevity and Nutrition Highlights</h3>
        <p>
          Enjoy a balanced, longevity-focused breakfast with this nutrient-dense
          oatmeal recipe, perfect for sustained energy and overall health. Key
          benefits include:
        </p>
        <ul>
          <li>
            <strong>Heart Health:</strong> Fiber and monounsaturated fats from
            pecans support cardiovascular health and may help lower LDL
            cholesterol.
          </li>
          <li>
            <strong>Brain Health:</strong> Omega-3s from flax seeds and
            additional monounsaturated fats from pecans promote cognitive
            function.
          </li>
          <li>
            <strong>Antioxidants:</strong> Blueberries, raisins, and pecans
            offer phenolic compounds and antioxidants, combating oxidative
            stress.
          </li>
          <li>
            <strong>Sustained Energy:</strong> Balanced mix of protein, fiber,
            and fats from multiple sources supports steady blood sugar levels
            throughout the morning.
          </li>
        </ul>
        <br></br>
        <h2 id="mediterranean-salad">Mediterranean Salad</h2>
        <h3>Ingredients</h3>
        <ul>
          <li>1 cup organic kidney beans</li>
          <li>1 cup organic chickpeas</li>
          <li>1/2 organic bell pepper, diced</li>
          <li>1/4 cucumber, diced</li>
          <li>1/4 purple onion, diced</li>
          <li>Salt and pepper to taste</li>
          <li>2 tablespoons olive oil</li>
          <li>Juice of 1/2 lemon</li>
        </ul>
        <p>Note: Feel free to customize this salad by adding other vegetables like cherry tomatoes or olives for extra flavor.</p>
        <h3>Instructions</h3>
        <ul>
          <li>In a large bowl, combine the kidney beans and chickpeas.</li>
          <li>Add the diced bell pepper, cucumber, and purple onion to the bowl.</li>
          <li>Drizzle with olive oil and squeeze the lemon juice over the top.</li>
          <li>Season with salt and pepper, then toss everything together until well mixed.</li>
          <li>Let the salad sit for about 10 minutes for the flavors to meld before serving.</li>
        </ul>

        <h3>Estimated Nutritional Breakdown</h3>
        <ul>
          <li>
            Organic Kidney Beans (1 cup): Calories: 225 | Protein: 15g | Fiber: 13g |
            Healthy Fats: 0.9g | Carbs: 40g
          </li>
          <li>
            Organic Chickpeas (1 cup): Calories: 269 | Protein: 14.5g | Fiber: 12.5g |
            Healthy Fats: 4g | Carbs: 45g
          </li>
          <li>
            Organic Bell Pepper (1/2): Calories: 12 | Protein: 0.5g | Fiber: 0.5g |
            Healthy Fats: 0.2g | Carbs: 3g
          </li>
          <li>
            Cucumber (1/4): Calories: 4 | Protein: 0.2g | Fiber: 0.1g | Healthy
            Fats: 0g | Carbs: 1g
          </li>
          <li>
            Purple Onion (1/4): Calories: 11 | Protein: 0.3g | Fiber: 0.3g | Healthy
            Fats: 0g | Carbs: 3g
          </li>
          <li>
            Olive Oil (2 tablespoons): Calories: 239 | Protein: 0g | Fiber: 0g |
            Healthy Fats: 27g | Carbs: 0g
          </li>
          <li>
            Lemon Juice (from 1/2 lemon): Calories: 6 | Protein: 0.2g | Fiber: 0.2g |
            Healthy Fats: 0g | Carbs: 2g
          </li>
        </ul>
        <p>
          Totals: Calories: 766 | Protein: 30.7g | Fiber: 26.6g | Healthy Fats:
          32.1g | Carbs: 91g
        </p>

        <h3>Key Vitamins and Minerals</h3>
        <ul>
          <li>Vitamin C from bell pepper and lemon juice (immune support)</li>
          <li>Iron from chickpeas and kidney beans (supports oxygen transport)</li>
          <li>Magnesium from beans (muscle and nerve function)</li>
          <li>Folate from chickpeas (cell division and DNA synthesis)</li>
          <li>Potassium from cucumber (heart health)</li>
          <li>Antioxidants from onions (anti-inflammatory properties)</li>
        </ul>

        <h3>Longevity and Nutrition Highlights</h3>
        <p>
          This Mediterranean Salad is a refreshing and nutrient-rich dish, perfect for a healthy lunch or dinner. Key benefits include:
        </p>
        <ul>
          <li>
            <strong>Heart Health:</strong> The fiber and healthy fats from olive oil support cardiovascular health and may help lower cholesterol levels.
          </li>
          <li>
            <strong>Digestive Health:</strong> High fiber content from beans and vegetables promotes healthy digestion and regularity.
          </li>
          <li>
            <strong>Antioxidants:</strong> The fresh vegetables provide antioxidants that combat oxidative stress and inflammation.
          </li>
          <li>
            <strong>Plant-Based Protein:</strong> A great source of protein from kidney beans and chickpeas, ideal for a vegetarian diet.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Recipes;

